import { useState } from 'react';
import { useSearchBox } from 'react-instantsearch';
import { useIntl } from 'react-intl';
import { useDebounce } from 'react-use';

import { SearchInput } from '@sorare/core/src/atoms/inputs/SearchInput';
import { glossary } from '@sorare/core/src/lib/glossary';

export const PlayerSearchInput = () => {
  const { formatMessage } = useIntl();

  const [inputValue, setInputValue] = useState<string>();

  const { refine } = useSearchBox();

  useDebounce(
    () => {
      if (typeof inputValue === 'string') {
        refine(inputValue);
      }
    },
    300,
    [inputValue]
  );

  return (
    <SearchInput
      placeholder={formatMessage(glossary.search)}
      fullWidth
      onChange={({ target }) => setInputValue(target.value)}
    />
  );
};
